import api from './api';
import { Service, ServiceForm } from '../types';

export type { Service, ServiceForm } from '../types';

export const servicesApi = {
  // Получение списка услуг
  async getServices(activeOnly: boolean = true): Promise<Service[]> {
    const response = await api.get(`/api/services?active_only=${activeOnly}`);
    return response.data;
  },

  // Получение услуги по ID
  async getService(id: number): Promise<Service> {
    const response = await api.get(`/api/services/${id}`);
    return response.data;
  },

  // Создание услуги
  async createService(serviceData: ServiceForm): Promise<Service> {
    const response = await api.post('/api/services', serviceData);
    return response.data;
  },

  // Обновление услуги
  async updateService(id: number, serviceData: Partial<ServiceForm>): Promise<Service> {
    const response = await api.put(`/api/services/${id}`, serviceData);
    return response.data;
  },

};

